declare global {
  interface Window {
    renderTurnstile?: () => void
    CareEv?: {
      WaitForClientVerificationToken: () => Promise<void>
    }
  }
}

export const UserType = {
  participant: "PARTICIPANT",
  coordinator: "COORDINATOR",
}

export type LoginLink = {
  Name: string;
  Id?: string;
  Href?: string;
  IsPreferred?: boolean;
  Title?: string;
};

export type ClientError = 'noAccountLogin' | 'accountExists' | 'externalAccountExists';

export type Project = {
  Name: string;
  Description: string;
  OrganizationName: string;
  OrganizationID: string;
  StudyCode: string;
  OrganizationHexColor: string;
  Enrolled: boolean;
  SupportedLocales: string[];
  DefaultLocale: string;
  RequiresIdentifierValidation: boolean;
};

export type AccountStatus = {
  Exists: boolean;
  ExistsInExternalProvider: boolean;
  NormalizedEmailOrPhone: string;
  RedirectUrl: string;
  Type: string;
}

export type Locale = {
  Code: string;
  IsDefault: boolean;
  Language: string;
  LocalizedName: string;
}

export type Brand = {
  ProductName: string;
  SplashLogoPath: string;
  BannerLogoPath: string;
}

export enum IdentityServerReloginState {
  'None' = 'None',
  'UserAction' = 'UserAction',
  'Inactivity' = 'Inactivity',
}

export type Translate = {
  use: (language?: string) => Promise<string>
}

export type Cookies = {
  get: (key: string) => string
  put: (key: string, value: string | null, options?: { expires?: Date }) => void
}

export interface UserPasskey {
  id: string
  description: string
  type?: string
  dateCreated?: string
}